import React from "react";
import styled from "@emotion/styled";
import { Box, Theme, useMediaQuery } from "@mui/material";
import { toCurrency } from "@helpers";
import { MandatorTypography } from "@components/MandatorTypography";
import { RangeSelector } from "./common";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface TableSummaryProps {
  currencySymbol: string;
  summaryValue: number;
  intervalType: IntervalType;
  onSelectInterval: (interval: IntervalType) => void;
  onSelectCustomInterval: (from: Date, to: Date) => void;
  range?: RangeType;
}

const intervalTypes: IntervalType[] = [
  "oneMonth",
  "sixMonths",
  "oneYear",
  "sinceBeginning",
  "custom",
];

export const TableSummary = ({
  summaryValue = 0,
  currencySymbol = "EUR",
  intervalType,
  range,
  onSelectCustomInterval,
  onSelectInterval,
}: TableSummaryProps) => {
  const isLessSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Container>
      <Wrapper>
        <MandatorTypography variant="h4">
          {toCurrency(summaryValue, currencySymbol)}
        </MandatorTypography>
        {!isLessSm && (
          <div>
            <RangeSelector
              intervalType={intervalType}
              intervalTypes={intervalTypes}
              range={intervalType === "custom" ? range : undefined}
              onSelect={onSelectInterval}
              onCustomSelect={onSelectCustomInterval}
            />
          </div>
        )}
      </Wrapper>
      {isLessSm && (
        <RangeSelector
          intervalType={intervalType}
          intervalTypes={intervalTypes}
          range={intervalType === "custom" ? range : undefined}
          onSelect={onSelectInterval}
          onCustomSelect={onSelectCustomInterval}
        />
      )}
    </Container>
  );
};
